import {selector} from './selector';
import * as events from "./events";

const PageLogin = (function ($) {

    function initEvents() {
        $(document).on('click', selector.passwordVisibility, events.changePasswordVisibility);
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageLogin};